import type { ComponentProps } from 'react';

const ChevronDown = (props: ComponentProps<'svg'>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3212_68258)">
      <path
        d="M30.5833 40.7542C31.3667 41.5375 32.6333 41.5375 33.4083 40.7542L49.4167 24.7542C50.2 23.9709 50.2 22.7042 49.4167 21.9292C48.6333 21.1542 47.3667 21.1459 46.5917 21.9292L32.0083 36.5125L17.4167 21.9209C16.6333 21.1375 15.3667 21.1375 14.5917 21.9209C13.8167 22.7042 13.8083 23.9709 14.5917 24.7459L30.5833 40.7542Z"
        fill={props?.fill ?? '#8C98AB'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1177 21.452C15.155 20.4036 16.8458 20.4072 17.8881 21.4495L32.0083 35.5698L46.1178 21.4604C46.1172 21.4609 46.1182 21.4599 46.1178 21.4604C47.1583 20.4103 48.8476 20.4284 49.8855 21.4553C50.934 22.4926 50.9304 24.1834 49.8881 25.2257L33.8823 41.2231C33.8818 41.2236 33.8827 41.2227 33.8823 41.2231C32.8448 42.2702 31.1538 42.2675 30.1119 41.2257L14.1228 25.2198C14.1223 25.2193 14.1233 25.2203 14.1228 25.2198C13.0727 24.1793 13.0908 22.49 14.1177 21.452ZM16.9453 22.3923C16.4209 21.8679 15.5783 21.8716 15.0656 22.3898C14.543 22.918 14.5455 23.7625 15.0605 24.272L15.0633 24.2747L31.0547 40.2828C31.5791 40.8072 32.4217 40.8036 32.9344 40.2854L32.937 40.2827L48.9453 24.2828C48.9452 24.2829 48.9453 24.2828 48.9453 24.2828C49.4695 23.7584 49.466 22.9158 48.9478 22.4032C48.4196 21.8806 47.5751 21.8831 47.0656 22.3981L47.0631 22.4007L32.0083 37.4554L16.9453 22.3923Z"
        fill={props?.fill ?? '#8C98AB'}
      />
    </g>
    <defs>
      <clipPath id="clip0_3212_68258">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ChevronDown;
